import { render, staticRenderFns } from "./HrClosingBanners.vue?vue&type=template&id=ad5c8226"
import script from "./HrClosingBanners.vue?vue&type=script&lang=js"
export * from "./HrClosingBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports